import React  from 'react';
import BtnSubmit from '../../../../Shared/Buttons/BtnSubmit';


const SaleFooter = (props) => {

  if(!props.isDisplayFooter){
    return null;
  }

  return (
    <>
      <footer className="energy-sale-block-footer">
        <div className='error'>{props.error}</div>
        <BtnSubmit
                isBusiness={false}
                text={props.btnText}
                onclick={props.onclick}
                formid={props.formid}
                isDisplayWhatsAppIcon={props.isDisplayWhatsAppIcon}
              />
          {props.linkText && <a href="#" onClick={props.onClickLink}>{props.linkText}</a>}
      </footer>

    </>
  );
};

export default SaleFooter;
